// / <reference types="@angular/localize" />
// import '@angular/common/locales/global/ro';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { Amplify, type ResourcesConfig } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';
import awsmobile  from './aws-exports';
import { fetchAuthSession } from 'aws-amplify/auth';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

// export const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
Amplify.configure(awsmobile);

const existingConfig = Amplify.getConfig();
// Amplify.configure({
//   ...existingConfig,
//   API: {
//     ...existingConfig.API,
//     REST: outputs.custom.API,
//   },
// });

cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

// export function HttpLoaderFactory(httpClient: HttpClient) {
//   return new TranslateHttpLoader(httpClient, environment.feServerUrl + '/assets/i18n/', '-lang.json');
// }

bootstrapApplication(AppComponent, {

  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(), provideAnimationsAsync('noop'), provideAnimationsAsync('noop'),
  ],
  

});


